import React, { useState, useEffect, useRef } from "react";
import { Popup, Swiper, Image } from "antd-mobile";
import useActiveState from "../../lib/useActiveState";
import "./css/Mask.css";
import osName from "../../OsName";
import { useLocalStorageState } from "ahooks";
import MobileDetect from "mobile-detect";
import { inWechat } from "../wechat/Index";
import IllustratedTutorial from "./IllustratedTutorial";
import IllustratedTutorial27 from "./IllustratedTutorial27";

const mobileDetect = new MobileDetect(navigator.userAgent);

/** 从 UA 解析 iOS 主版本号 */
function getIOSVersion() {
  // 优先 Version/（针对 Version 与 OS 版本不一致的情况），再试 OS
  let match = navigator.userAgent.match(/Version\/(\d+)[_.]/);
  if (!match) {
    match = navigator.userAgent.match(/OS\s+(\d+)[_.]/);
  }
  if (match && match[1]) {
    return parseInt(match[1], 10);
  }
  const versionStr = mobileDetect.versionStr("iPhone");
  if (versionStr) {
    return parseInt(versionStr.split("_")[0], 10);
  }
  return 0;
}

export default function Mask() {
  const [app] = useActiveState("app");
  const [start, setStart] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [init, setInit] = useState(false);
  const [index, setIndex] = useState(0);
  const swiper = useRef();
  const array = ["", "", ""];
  const harmonyArray = ["", ""];
  const [harmonyFlag, setHarmonyFlag] = useLocalStorageState("harmonyFlag", 0);
  // iOS 引导图版本：27 / 26 / 0（旧版 start.png）
  const [iosGuideVersion, setIosGuideVersion] = useState(0);
  const [visible, setVisible] = useState(false);
  const [switchingSteps, setSwitchingSteps] = useState(false);

  const harmonyItems = harmonyArray.map((item, index) => (
    <Swiper.Item key={index}>
      <div className="swipe-pic">
        <Image src={`resources/mask/harmony_${index + 1}.gif`} />
        <div className="swipe-pic-index">第{index + 1}步</div>
      </div>
    </Swiper.Item>
  ));

  const items = array.map((item, index) => (
    <Swiper.Item key={index}>
      <div className="swipe-pic">
        {app.appname.search("01") !== -1 ? (
          <Image src={`resources/mask/01-${index + 1}.gif`} />
        ) : app.appname.search("05") !== -1 ? (
          <Image src={`resources/mask/05-${index + 1}.gif`} />
        ) : app.appname.search("惠爪") !== -1 ? (
          <Image src={`resources/mask/hz-${index + 1}.gif`} />
        ) : (
          <Image src={`resources/mask/${index + 1}_1.gif`} />
        )}
        <div className="swipe-pic-index">第{index + 1}步</div>
      </div>
    </Swiper.Item>
  ));

  useEffect(() => {
    if (osName() == "Harmony") {
      setHarmonyFlag(1);
      setHidden(true);
      setTimeout(() => {
        setIndex(1);
      }, 3000);
      return;
    }

    const version = getIOSVersion();
    if (version >= 27) {
      setIosGuideVersion(27);
    } else if (version >= 26) {
      setIosGuideVersion(26);
    } else {
      setIosGuideVersion(0);
      setTimeout(() => {
        setStart(true);
      }, 10000);
    }
  }, []);

  useEffect(() => {
    if (start && !init) {
      setInit(true);
      setTimeout(() => {
        setHidden(true);
      }, 750);
      setTimeout(() => {
        setIndex(1);
      }, 2000);
    }
  }, [start]);

  useEffect(() => {
    if (osName() == "Harmony") {
      if (index == 0) {
        setTimeout(() => {
          setIndex(1);
          swiper.current.swipeNext();
        }, 3000);
      } else {
        setTimeout(() => {
          setIndex(0);
          swiper.current.swipeNext();
        }, 3000);
      }
    } else {
      if (index == 0) {
        setTimeout(() => {
          setIndex(1);
          swiper.current.swipeNext();
        }, 2000);
      } else {
        const time = index == 2 ? 2000 : 3000;
        setTimeout(() => {
          setIndex(index == 2 ? 0 : 2);
          swiper.current.swipeNext();
        }, time);
      }
    }
  }, [index]);

  const renderModernTips = () => (
    <div style={{ padding: "0px 25px", color: "#282828", fontSize: 14 }}>
      <div
        style={{
          backgroundColor: "#fafafa",
          padding: "10px 15px",
          borderRadius: 8,
          lineHeight: 1.8,
        }}
      >
        <div style={{ fontWeight: 500 }}>无法正常添加桌面应用？可尝试：</div>
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          {iosGuideVersion >= 27 ? (
            <>
              1、找不到
              <img
                src="resources/mask/share_27.png"
                alt="分享"
                style={{ width: 16, height: 16, margin: "0 2px", verticalAlign: "middle" }}
              />
              按钮？
            </>
          ) : (
            <>1、找不到“···”按钮？</>
          )}
          <span
            onClick={() => {
              setSwitchingSteps((e) => !e);
            }}
            style={{ textDecoration: "underline", color: "var(--MainColor)" }}
          >
            切换添加步骤
          </span>
        </div>
        <div>
          2、
          <span
            onClick={() => setVisible(true)}
            style={{ textDecoration: "underline", color: "var(--MainColor)" }}
          >
            查看图文教程
          </span>
        </div>
      </div>
    </div>
  );

  // 按 iOS 版本渲染引导图 + 图文教程
  const renderGuideImages = () => {
    if (iosGuideVersion >= 27) {
      return (
        <>
          <Image
            className="mask-pic"
            src="resources/mask/start_27.png"
            style={{ display: switchingSteps ? "none" : "block" }}
          />
          <Image
            className="mask-pic"
            src="resources/mask/start_27_1.png"
            style={{ display: switchingSteps ? "block" : "none" }}
          />
          {renderModernTips()}
          <IllustratedTutorial27 visible={visible} onClose={() => setVisible(false)} />
        </>
      );
    }
    if (iosGuideVersion >= 26) {
      return (
        <>
          <Image
            className="mask-pic"
            src="resources/mask/start_26.png"
            style={{ display: switchingSteps ? "none" : "block" }}
          />
          <Image
            className="mask-pic"
            src="resources/mask/start_26_1.png"
            style={{ display: switchingSteps ? "block" : "none" }}
          />
          {renderModernTips()}
          <IllustratedTutorial visible={visible} onClose={() => setVisible(false)} />
        </>
      );
    }
    // 旧版 iOS：默认引导图
    return <Image className="mask-pic" src="resources/mask/start.png" />;
  };

  return (
    <div>
      {!inWechat() && (
        <Popup
          className="mask-index"
          visible={true}
          bodyStyle={{
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            overflow: "hidden",
          }}
        >
          <div className="mask-header">
            <Image
              className="mask-header-icon"
              src={app.appicon}
              style={{ borderRadius: 8 }}
            />
            <div className="mask-content">
              <div className="mask-content-title">快速添加桌面应用</div>
              <div className="mask-content-desc">便捷启动·全屏体验</div>
            </div>
          </div>
          <div className="mask-container">
            {hidden ? (
              <Swiper defaultIndex={0} ref={swiper} loop={true}>
                {osName() == "Harmony" ? harmonyItems : items}
              </Swiper>
            ) : null}
            <div
              className="mask-pic-index"
              style={{
                opacity: start ? "0" : "1",
                display: hidden ? "none" : "",
              }}
            >
              {renderGuideImages()}
            </div>
          </div>
        </Popup>
      )}
    </div>
  );
}
